export default __webpack_public_path__ + "static/media/new-icon-dashboard.aeb9a4d0.svg";